import { Box, Grid, Tab, Tabs } from '@mui/material';
import { Field, FieldProps } from 'formik';
import { get } from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledErrorMessage } from '../StyledErrorMessage';
import { useAuth } from '../../session/InternalAuthProvider';
import { AccountData, Language } from '../../api';
import { RichTextEditor } from '../../common/ui/RichTextEditor';
import { stripSingleParagraphWrapper } from '../saveHeader/richTextDiff';

export const FormRichTextField = ({ labelFieldName, disabled }: { labelFieldName: string; disabled: boolean }) => {
  const { t } = useTranslation();
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const languages = account.customer_facing_widgets_languages;
  const [activeTab, setActiveTab] = useState(languages[0]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: Language) => {
    setActiveTab(newValue);
  };

  return (
    <Grid container flexDirection="column">
      {languages.length > 1 && (
        <Tabs value={activeTab} onChange={handleTabChange} aria-label="language tabs">
          {languages.map((lang) => (
            <Tab key={lang} label={t(`emailTemplates.${lang}`)} value={lang} />
          ))}
        </Tabs>
      )}
      {languages.map((lang) => (
        <Box key={lang} mt={2} display={activeTab === lang ? 'block' : 'none'}>
          <Field name={`${labelFieldName}.${lang}`}>
            {({ field, form }: FieldProps<string>) => {
              const initialValue = get(form.initialValues, field.name) || '';
              const isChanged = field.value && field.value !== initialValue;
              return (
                <Box
                  sx={{
                    '& .ql-container': {
                      borderColor: isChanged ? 'primary.main' : undefined,
                      borderWidth: isChanged ? '2px' : undefined,
                    },
                    '& .ql-toolbar': {
                      borderColor: isChanged ? 'primary.main' : undefined,
                      borderWidth: isChanged ? '2px' : undefined,
                    },
                  }}>
                  <RichTextEditor
                    value={field.value || ''}
                    onChange={(value) => {
                      const initialStr = (get(form.initialValues, field.name) as string) || '';
                      if (stripSingleParagraphWrapper(value) === stripSingleParagraphWrapper(initialStr)) {
                        if ((field.value || '') !== initialStr) void form.setFieldValue(field.name, initialStr);
                        return;
                      }
                      void form.setFieldValue(field.name, value);
                    }}
                    readOnly={disabled}
                    contentLanguage={lang}
                  />
                </Box>
              );
            }}
          </Field>
          <StyledErrorMessage name={`${labelFieldName}.${lang}`} />
        </Box>
      ))}
    </Grid>
  );
};
